import { proxy, subscribe } from 'valtio';
import { AuthState } from './lib/types';

function getInitialState(): AuthState {
  const serviceId = localStorage.getItem('serviceId') || '';
  const serviceName = localStorage.getItem('serviceName') || '';

  return {
    loading: false,
    loadingState: 'none',
    signedIn: false,
    token: '',
    user: undefined,
    serviceId,
    serviceName,
    error: undefined,
  };
}

export const authState = proxy<AuthState>(getInitialState());

subscribe(authState, () => {
  localStorage.setItem('serviceId', authState.serviceId || '');
  localStorage.setItem('serviceName', authState.serviceName || '');
});
